module.exports = __webpack_public_path__ + "png.png?e66b1d2284d487ba2631e91f29ecec6f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconImg/png.png
// module id = 127
// module chunks = 0